import { render, staticRenderFns } from "./portability.vue?vue&type=template&id=3653f3be"
import script from "./portability.vue?vue&type=script&lang=js"
export * from "./portability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports